import { Form } from "react-bootstrap";

export const FormFileUpload = (param) => {
  // const [file, setFile] = useState(null);
  // const [fileName, setFileName] = useState("");

  // const handleFileChange = (event) => {
  //   const files = event.target.files;
  //   if (files.length === 0) {
  //     setFileName(""); // Clear the fileName state
  //   } else {
  //     // Files are selected, update the file name state
  //     const selectedFile = Array.from(files)
  //       .map((file) => file.name)
  //       .join(", ");
  //     setFileName(selectedFile);
  //   }
  // };

  return (
    <Form.Group className={param.className} controlId={param.id}>
      <Form.Label>{param.label}</Form.Label>
      <Form.Control
        type="file"
        multiple={param.multiple}
        style={{
          backgroundColor: "transparent",
          color: "white",
        }}
        onChange={param.onChange}
        {...param.control}
      />
      {/* {fileName && <p>Selected file: {fileName}</p>} */}

      {param.error && <p className="text-danger">{param.error.message}</p>}
    </Form.Group>
  );
};

export default FormFileUpload;
